import { createApi } from "../../../utils/createApi";
import { createMonitoringAPICall } from "../../../utils/createMonitoringAPICall";
import { AxiosResponse } from "axios";
import { Dispatcher } from "../../Sites/SiteAboutPage/SiteAboutPageUtils/siteAboutInterfaces";

// PROD-27: mute/unmute history for a site, from monitoring-api's durable
// MUTEAUDIT# rows (survives unmute + TTL reaping — unlike the per-user
// muted lists behind the "See Muted" dialog, which are pruned on unmute).
export interface MuteHistoryEvent {
  action: "mute" | "unmute";
  ts: number; // epoch seconds
  scope: "camera" | "site";
  camera_pk: string; // the camera the operator clicked
  camera_ids: string[]; // every camera affected (site scope expands)
  camera_count: number;
  duration_minutes: number | null; // mute only
  expires_at: number | null; // epoch seconds, mute only
  user: string | null;
  user_pk: number | null;
  source_ip: string | null;
}

export const MUTE_HISTORY_DAYS = 90;

// Fails SOFT on purpose: this tab is supplementary to the general action
// logs (which already handle auth errors for the page), and the endpoint
// may not exist yet in an environment where camera-ui shipped ahead of
// monitoring-api. A failure marks the tab unavailable instead of bouncing
// the user through the global error handler.
export const handleFetchMuteHistoryData = (
  siteId: string,
  setMuteHistoryData: Dispatcher<MuteHistoryEvent[]>,
  setCameraNames: Dispatcher<Map<string, string>>,
  setFetchingMuteHistoryData: Dispatcher<boolean>,
  setMuteHistoryUnavailable: Dispatcher<boolean>
) => {
  const MonitoringAPI = createMonitoringAPICall(``);
  const AxiosUI = createApi(``);

  const to = Math.floor(Date.now() / 1000);
  const from = to - MUTE_HISTORY_DAYS * 86400;

  MonitoringAPI.get(
    `streaming/mute-history/?customer=${siteId}&from=${from}&to=${to}&limit=500`
  ).then(
    (response: AxiosResponse) => {
      setMuteHistoryData(response.data.events ?? []);
      setMuteHistoryUnavailable(false);
      // Camera names for the pk list — best effort; ids still render if it fails.
      AxiosUI.get(`camera/site/?customer__id=${siteId}`).then(
        (response: AxiosResponse) => {
          const names = new Map<string, string>();
          (response.data.results ?? []).forEach((camera: any) => {
            names.set(String(camera.id), camera.camera_name);
          });
          setCameraNames(names);
          setFetchingMuteHistoryData(false);
        },
        () => {
          setFetchingMuteHistoryData(false);
        }
      );
    },
    () => {
      setMuteHistoryData([]);
      setMuteHistoryUnavailable(true);
      setFetchingMuteHistoryData(false);
    }
  );
};
